import api from '../lib/api';

const userService = {
    getUsers: async (params) => {
        try {
            const response = await api.get('/admin/users', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching users:', error);
            throw error;
        }
    },

    getCurrentUser: async () => {
        try {
            const response = await api.get('/user');
            return response.data;
        } catch (error) {
            console.error('Error fetching current user:', error);
            throw error;
        }
    },

    createUser: async (userData) => {
        try {
            const response = await api.post('/admin/users', userData);
            return response.data;
        } catch (error) {
            console.error('Error creating user:', error);
            throw error;
        }
    },

    getUser: async (userId) => {
        try {
            const response = await api.get(`/admin/users/${userId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching user:', error);
            throw error;
        }
    },

    updateUser: async (userId, userData) => {
        try {
            // Check if userData contains a File (profile_image)
            const hasFile = userData.profile_image instanceof File;
            
            if (hasFile) {
                // Create FormData for file uploads
                const formData = new FormData();
                
                Object.keys(userData).forEach(key => {
                    if (key === 'profile_image' && userData[key] instanceof File) {
                        formData.append(key, userData[key]);
                    } else {
                        const value = userData[key];
                        if (value !== null && value !== undefined) {
                            formData.append(key, value === '' ? '' : value);
                        }
                    }
                });
                
                const response = await api.post(`/users/${userId}`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                return response.data;
            } else {
                // Regular JSON request - still use POST for consistency
                const formData = new FormData();
                Object.keys(userData).forEach(key => {
                    const value = userData[key];
                    if (value !== null && value !== undefined) {
                        formData.append(key, value === '' ? '' : value);
                    }
                });
                
                const response = await api.post(`/users/${userId}`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
            return response.data;
            }
        } catch (error) {
            console.error('Error updating user:', error);
            throw error;
        }
    },

    deleteUser: async (userId) => {
        try {
            const response = await api.delete(`/admin/users/${userId}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting user:', error);
            throw error;
        }
    },

    getProfile: async () => {
        try {
            const response = await api.get('/profile');
            return response.data;
        } catch (error) {
            console.error('Error fetching profile:', error);
            throw error;
        }
    },

    updateProfile: async (userData) => {
        try {
            const response = await api.put('/profile', userData);
            return response.data;
        } catch (error) {
            console.error('Error updating profile:', error);
            throw error;
        }
    },

    deleteProfileImage: async (userId) => {
        try {
            const formData = new FormData();
            formData.append('delete_profile_image', '1');
            
            const response = await api.post(`/users/${userId}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data;
        } catch (error) {
            console.error('Error deleting profile image:', error);
            throw error;
        }
    },

    changePassword: async (passwordData) => {
        try {
            const response = await api.put('/profile/password', passwordData);
            return response.data;
        } catch (error) {
            console.error('Error changing password:', error);
            throw error;
        }
    },

    changeRequiredPassword: async (passwordData) => {
        try {
            const response = await api.post('/change-required-password', passwordData);
            return response.data;
        } catch (error) {
            console.error('Error changing required password:', error);
            throw error;
        }
    },

    getMyBids: async () => {
        try {
            const response = await api.get('/my-bids');
            return response.data;
        } catch (error) {
            console.error('Error fetching bids:', error);
            throw error;
        }
    },

    getWinningBids: async () => {
        try {
            const response = await api.get('/winning-bids');
            return response.data;
        } catch (error) {
            console.error('Error fetching winning bids:', error);
            throw error;
        }
    }
};

export default userService;
